import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.g9{min-height:100vh;}.ssr-plugin'
import '.do{background:var(--palette-white);}.ssr-plugin'
import '.ad{max-width:77.5rem;}.ssr-plugin'
import '.ga{align-self:center;}.ssr-plugin'
import '.aq{flex-shrink:0;}.ssr-plugin'
import '.gb{padding-block:1rem;}.ssr-plugin'
import '.f6{gap:0.75rem;}.ssr-plugin'
import '.gc{height:3rem;}.ssr-plugin'
import '.ag{justify-content:space-between;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.aj{flex-wrap:wrap;}.ssr-plugin'
import '.gd{height:0.25rem;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ge{border-radius:999px;}.ssr-plugin'
import '.gf{background:var(--gray-200);}.ssr-plugin'
import '.ar{height:100%;}.ssr-plugin'
import '.ci{background:var(--brand-primary);}.ssr-plugin'
import '.gg{transition:width 0.3s ease;}.ssr-plugin'
import '.at{flex:1;}.ssr-plugin'
import '.dk{min-height:0px;}.ssr-plugin'
import '.r{align-items:stretch;}.ssr-plugin'
import '.gh{padding-bottom:1.5rem;}.ssr-plugin'
import { ReactNode, useEffect } from 'react'
import { styled } from 'inlines'
import { Property } from 'csstype'
import useMediaQuery from '@app/util/useMediaQuery'
import { Title } from '@app/components/core/typography/Title'
import { CloseButton } from '@app/components/core/button/CloseButton'
import { pages } from '@app/util/links'
import { useLocation } from 'wouter'
import { ClientOnly, useAuthState } from '@based/sdk/react'

export const InitiativeCreatePageLayout = ({
  title,
  gap = '1rem',
  children,
  onClose,
  progress,
}: {
  title: string
  gap?: Property.Gap<(string & {}) | 0>
  children: ReactNode
  onClose: VoidFunction
  progress?: { current: number; total: number }
}) => {
  const isMobile = useMediaQuery()

  const authState = useAuthState()
  const [_location, navigate] = useLocation()
  const isAuthed = authState && authState.userId

  useEffect(() => {
    if (!isAuthed) {
      navigate(pages.home)
    }
  }, [isAuthed, navigate])

  return (
    <ClientOnly>
      <div className="a b g9 do"
      >
        <div className="ad ga aq"
          style={{
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          <nav className="gb a b f6"
          >
            <div className="gc a ag t aj"
            >
              <Title.H5>{title}</Title.H5>
              <CloseButton onClick={onClose} />
            </div>
            {progress && progress.total > 0 && (
              <div className="gd n ge gf"
              >
                <div className="ar ge ci gg"
                  style={{
                    width: `${(progress.current / progress.total) * 100}%`,}}
                />
              </div>
            )}
          </nav>
        </div>
        <div className="at dk a b r gh ad ga"
          style={{
            gap: gap,
            width: isMobile ? '100%' : '85%',
            paddingInline: isMobile ? '5rem' : 0,}}
        >
          {children}
        </div>
      </div>
    </ClientOnly>
  )
}
